(function() {
  // Event delegation sul body - funziona anche per elementi caricati dinamicamente
  document.body.addEventListener('click', function(e) {
    const dot = e.target.closest('.color-dot');
    if (!dot) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const card = dot.closest('product-card');
    if (!card) return;
    
    const newImg = dot.getAttribute('data-image-url');
    const newSecImg = dot.getAttribute('data-secondary-image-url');
    const newUrl = dot.getAttribute('data-product-url');
    const newTitle = dot.getAttribute('data-product-title');
    
    // Trova gli elementi (primary è già l'img, non un contenitore)
    const primary = card.querySelector('.product-primary-image');
    const figure = card.querySelector('.product-card--featured-image');
    const links = card.querySelectorAll('a[href*="/products/"]');
    const title = card.querySelector('.product-card-title');
    
    // Cambia immagine primaria
    if (primary && newImg) {
      primary.src = newImg;
      primary.srcset = newImg;
    }
    
    // Gestisci immagini secondarie
    if (figure) {
      const mainLink = figure.querySelector('.product-card--featured-image-link');
      
      // Rimuovi tutte le immagini secondarie esistenti
      const allSecondaryDivs = figure.querySelectorAll('.product-secondary-image');
      allSecondaryDivs.forEach(function(div) {
        div.remove();
      });
      
      // Crea nuova immagine secondaria SOLO se esiste e non è vuota o null
      if (newSecImg && newSecImg !== '' && newSecImg !== 'undefined' && newSecImg !== 'null' && newSecImg !== null && mainLink) {
        const newSecDiv = document.createElement('div');
        newSecDiv.className = 'product-secondary-image';
        newSecDiv.innerHTML = '<img src="' + newSecImg + '" srcset="' + newSecImg + '" width="2048" height="2048" alt="" loading="eager" class="product-secondary-image" />';
        mainLink.appendChild(newSecDiv);
      }
    }
    
    // Cambia link
    if (newUrl) {
      links.forEach(function(link) {
        link.href = newUrl;
      });
    }
    
    // Cambia titolo
    if (title && newTitle) {
      title.textContent = newTitle;
    }
    
    // Gestisci stato active
    card.querySelectorAll('.color-dot').forEach(function(d) {
      d.classList.remove('active');
    });
    dot.classList.add('active');
  }, true);
})();
